const _ = require('lodash');

const GREEN = 'green-triangle';
const ORANGE = 'orange-triangle';
const PINK = 'pink-triangle';

const CAMPAIGN_COLORS = [GREEN, ORANGE, PINK];

const getHeroRandomBgColor = () => (_.sample(CAMPAIGN_COLORS));

module.exports = {
    DEFAULT_BG: GREEN,
    getHeroRandomBgColor
};
